<!--  -->
<template>
  <div>
    <div class="dmas">
      <div style="width:130px">请输入openid:</div>
      <el-input v-model="input" placeholder="请输入openid" />
    </div>
    <div style="margin-top:50px">
      <el-button type="primary" size="mini" @click="dakw">确定</el-button>
    </div>
  </div>
</template>

<script>
import { testredpacketswell } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      input: '',
      app_id: null,
      red_packet_no: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(item) {
      this.app_id = item.app_id
      this.red_packet_no = item.red_packet_no
      console.log('item', item)
    },
    async dakw() {
      // eslint-disable-next-line eqeqeq
      if (this.input == '') {
        this.$message.error('请输入oppid')
        return
      }
      const data = await testredpacketswell({
        app_id: this.app_id,
        open_id: this.input,
        red_packet_no: this.red_packet_no
      })
      this.$message({
        type: 'success',
        message: '发送成功!'
      })
      console.log('data', data)
      this.$emit('updata')
    }
  }

}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dmas{
  display: flex;
  align-items: center;
}
</style>
